import { Card } from '@chakra-ui/react/card';
import { memo } from 'react';

import { QuarantineItem } from '../TestQuarantinePage.types';

const TestQuarantineDialogContent = memo(({ testQuarantineItem }: { testQuarantineItem: QuarantineItem }) => {
  const content = [...testQuarantineItem.testSuiteName];
  if (testQuarantineItem.className) {
    content.push(testQuarantineItem.className);
  }
  if (testQuarantineItem.testCaseName) {
    content.push(testQuarantineItem.testCaseName);
  }

  return (
    <Card.Root asChild elevation={false} paddingSize="sm">
      <Card.Body>{content.join(' / ')}</Card.Body>
    </Card.Root>
  );
});

TestQuarantineDialogContent.displayName = 'TestQuarantineDialogContent';

export default TestQuarantineDialogContent;
